import {CommonMessages} from '../../common.messages';

export const MessageRequestMessages = {
    GetMessageRequestFailed: {
        key: 'GetMessageRequestFailed',
        message: 'Error while communication with the server. Unable to get messages.'
    },
    GetMessageRequestNoData: {
        key: 'GetMessageRequestNoData',
        message: 'No messages data.'
    },
    CreateMessageRequestSucceeded: {
        key: 'CreateMessageRequestSucceeded',
        message: 'Message request is successfully created'
    },
    UpdateMessageRequestSucceeded: {
        key: 'UpdateMessageRequestSucceeded',
        message: 'Message request is successfully updated'
    },
    CreateMessageRequestFailed: {
        key: 'CreateMessageRequestFailed',
        message: 'Error while communication with the server. Unable to create message request.'
    },
    CreateMessageRequestFailedNoRecipient: {
        key: 'CreateMessageRequestFailedNoRecipient',
        message: 'At least 1 recipient is required'
    },
    CreateMessageRequestFailedNoKeyCode: {
        key: 'CreateMessageRequestFailedNoKeyCode',
        message: 'Key code is required'
    },
    TemplateNotFoundByCodeAndCompany: {
        key: 'TemplateNotFoundByCodeAndCompany',
        message: 'Template not found with given key code and company'
    },
    UpdateMessageRequestFailed: {
        key: 'UpdateMessageRequestFailed',
        message: 'Error while communication with the server. Unable to update message request.'
    },
    GetRecipientsFailed: {
        key: 'GetRecipientsFailed',
        message: 'Error while communication with the server. Unable to get recipients.'
    },
    GetKeyCodesFailed: {
        key: 'GetKeyCodesFailed',
        message: 'Error while communication with the server. Unable to get key codes.'
    },
    GetRecipientsNoData: {
        key: 'GetRecipientsNoData',
        message: 'No recipients data'
    },
    ...CommonMessages
};
